import { render } from "./myCoupons.vue?vue&type=template&id=372a86c9&scoped=true"
import script from "./myCoupons.vue?vue&type=script&lang=js"
export * from "./myCoupons.vue?vue&type=script&lang=js"

import "./myCoupons.vue?vue&type=style&index=0&id=372a86c9&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372a86c9"]])

export default __exports__